import BadgeComponent from "../BadgeComponent/BadgeComponent";
import { Header } from "antd/lib/layout/layout";
import DefectRegister from "../../store/defectRegister";
import { authStore } from "../../store/authStore";
import { toJS } from "mobx";
import { observer } from "mobx-react-lite";
import cn from "classnames";
import "./index.scss";
import styles from "./HeaderComponent.module.scss";

const HeaderComponent = observer(({ filter }) => {
  const { allOrgsView, defectNotify } = authStore;

  const scrollContainer = window.document.querySelector(".header");

  scrollContainer?.addEventListener("wheel", (event) => {
    event.preventDefault();
    scrollContainer.scrollLeft += event.deltaY;
  });

  const headerClassName = cn({
    "site-layout-background header": true,
    "open-pantl_left": !DefectRegister.siderCollapsed,
    "close-pantl_left": DefectRegister.siderCollapsed,
  });

  return (
    <>
      {(authStore && allOrgsView) || (authStore && defectNotify) ? (
        <Header className={headerClassName} id={styles.headerContainer}>
          {toJS(DefectRegister.infoPane?.data?.items.length) &&
            toJS(DefectRegister.infoPane?.data)?.items?.map((x) => {
              return (
                <BadgeComponent
                  key={x.gridType.name}
                  counts={{ red: x.filteredCount, gray: x.totalCount }}
                  title={x.gridType.title}
                  gridTypeId={x.gridType.id}
                  icon={x.gridType.name}
                />
              );
            })}
          {(DefectRegister.infoPane && allOrgsView) ||
          (DefectRegister.infoPane && defectNotify) ? (
            <div
              className={
                DefectRegister.siderCollapsed
                  ? "global-counts-wrapper global-counts-wrapper--collapsed"
                  : "global-counts-wrapper"
              }
            >
              <div>
                <p>Общее количество</p>
                <span className="global-counts">
                  {DefectRegister.infoPane?.data?.totalCount}
                </span>
              </div>
              <div>
                <p>С учетом фильтров</p>
                <span className="global-counts global-counts--filter">
                  {DefectRegister.infoPane?.data?.filteredCount}
                </span>
              </div>
            </div>
          ) : (
            <div></div>
          )}
        </Header>
      ) : (
        <></>
      )}
    </>
  );
});

export default HeaderComponent;
